import { nullToUndefinedDeep } from "@graffer-inc/cloud-gov-core";
import { ApplicationHistoriesQuery } from "@graffer-inc/smart-apply";
import { ApplicationHistory } from "./application-history";

export class ApplicationHistoryFactory {
  static createFromGql(
    res: ApplicationHistoriesQuery["applicationHistories"][number],
  ) {
    const history = nullToUndefinedDeep(res.applicationHistory);
    const internalComment = nullToUndefinedDeep(res.internalComment);
    return new ApplicationHistory({
      ...history,
      internalComment: internalComment || undefined,
    });
  }
}
